/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'truck': {
    width: 274,
    height: 219,
    viewBox: '0 0 274 219',
    data: '<path pid="0" d="M246.6 0h-137a27.416 27.416 0 00-27.4 27.375v13.688H54.8A54.835 54.835 0 000 95.813v82.125a13.692 13.692 0 0013.7 13.687h29.93a40.866 40.866 0 0077.15 0h46.15a40.866 40.866 0 0077.15 0h16.22a13.692 13.692 0 0013.7-13.687V27.375A27.416 27.416 0 00246.6 0zm0 27.375V164.25h-2.52a40.873 40.873 0 00-77.16 0h-46.14a40.941 40.941 0 00-11.18-16.689V27.375h137zM27.4 95.813a27.415 27.415 0 0127.4-27.375h27.4v68.437a41.047 41.047 0 00-38.58 27.375H27.4V95.813zm54.8 95.812a13.688 13.688 0 1113.7-13.687 13.713 13.713 0 01-13.7 13.687zm123.3 0a13.688 13.688 0 1113.7-13.687 13.713 13.713 0 01-13.7 13.687zm-137-109.5H41.1V109.5h27.4V82.125z" fill-rule="evenodd"/>'
  }
})
